import styles from "./Styles.module.css";

const CustomPaymentInput = (props) => {
  const {
    register,
    label,
    name,
    type,
    onchange,
    errors,
    placeholder,

    disabled,
    tabIndex,
    required = false,
  } = props;

  return (
    <div className={styles.formField}>
      <div className="flex  font-semibold text-[14px]  items-center">
        {label}{" "}
        {errors && (
          <div className="error-text">{errors?.message}</div>
        )}
      </div>
      <input
        tabIndex={tabIndex ? tabIndex : "0"}
        className="h-[52px] px-2 outline-none rounded-v-md w-full border-[1px] border-[#ccc] disabled:bg-neutral-10 disabled:border-none"
        {...register(name, {
          required: required && {
            value: true,
            message: "این فیلد اجباری است ", // Custom required message here
          },
        })}
        name={name}
        disabled={disabled}
        type={type}
        onKeyUp={onchange}
        placeholder={placeholder}
        onWheel={(e) => e.target.blur()}
      />
    </div>
  );
};

export default CustomPaymentInput;
